import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "page-wrap" }
const _hoisted_2 = { class: "panel-pad mb-4" }
const _hoisted_3 = { class: "flex flex-col gap-3" }
const _hoisted_4 = { class: "flex flex-wrap gap-2" }
const _hoisted_5 = { class: "grid min-w-0 grid-cols-1 gap-3 md:grid-cols-2 xl:grid-cols-[160px_160px_220px_minmax(0,1fr)_auto] items-end" }
const _hoisted_6 = ["value"]
const _hoisted_7 = {
  key: 0,
  class: "table-loading-overlay"
}
const _hoisted_8 = { class: "data-table min-w-[1780px]" }
const _hoisted_9 = { key: 0 }
const _hoisted_10 = { class: "divide-y divide-slate-100" }
const _hoisted_11 = { class: "font-semibold text-ink" }
const _hoisted_12 = {
  key: 0,
  class: "text-right"
}
const _hoisted_13 = { key: 0 }
const _hoisted_14 = ["colspan"]
const _hoisted_15 = {
  key: 0,
  class: "table-loading-overlay"
}
const _hoisted_16 = { class: "data-table min-w-[1900px]" }
const _hoisted_17 = { key: 0 }
const _hoisted_18 = { class: "divide-y divide-slate-100" }
const _hoisted_19 = { class: "font-semibold text-ink" }
const _hoisted_20 = {
  key: 0,
  class: "text-right"
}
const _hoisted_21 = { class: "inline-flex w-max justify-end gap-2" }
const _hoisted_22 = { key: 0 }
const _hoisted_23 = ["colspan"]
const _hoisted_24 = { class: "mb-4 flex items-start justify-between" }
const _hoisted_25 = { class: "text-xl font-bold text-ink" }
const _hoisted_26 = { class: "text-sm text-slate-500" }
const _hoisted_27 = {
  key: 0,
  class: "table-loading-overlay"
}
const _hoisted_28 = { class: "data-table min-w-[1500px]" }
const _hoisted_29 = { class: "divide-y divide-slate-100" }
const _hoisted_30 = { class: "font-semibold text-ink" }
const _hoisted_31 = { key: 0 }
const _hoisted_32 = { key: 1 }
const _hoisted_33 = ["value"]
const _hoisted_34 = {
  key: 2,
  class: "flex flex-col gap-4"
}
const _hoisted_35 = ["value"]
const _hoisted_36 = {
  key: 3,
  class: "flex flex-col gap-4"
}
const _hoisted_37 = { key: 4 }
const _hoisted_38 = { class: "text-sm font-semibold text-slate-600" }
const _hoisted_39 = { class: "font-bold text-ink" }
const _hoisted_40 = { key: 5 }
const _hoisted_41 = { class: "mt-4 flex justify-end gap-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_UiButton = _resolveComponent("UiButton")!
  const _component_UiPageHero = _resolveComponent("UiPageHero")!
  const _component_UiDatePicker = _resolveComponent("UiDatePicker")!
  const _component_UiSelect = _resolveComponent("UiSelect")!
  const _component_UiInput = _resolveComponent("UiInput")!
  const _component_UiPagination = _resolveComponent("UiPagination")!
  const _component_UiTextarea = _resolveComponent("UiTextarea")!
  const _component_UiModal = _resolveComponent("UiModal")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createVNode(_component_UiPageHero, {
      eyebrow: "Kho tài sản",
      title: "Quản lý toàn bộ thiết bị",
      description: "Tra cứu, lọc trạng thái, ngừng hoạt động, chờ thanh lý và xuất báo cáo."
    }, {
      actions: _withCtx(() => [
        _createVNode(_component_UiButton, {
          variant: "white",
          icon: "refresh",
          disabled: $setup.loading,
          onClick: $setup.reloadRowsAndCounts
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString($setup.loading ? "Đang tải..." : "Làm mới"), 1)
          ]),
          _: 1
        }, 8, ["disabled", "onClick"])
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.tabs, (tab) => {
            return (_openBlock(), _createBlock(_component_UiButton, {
              key: tab.key,
              icon: "view",
              variant: $setup.activeTab === tab.key ? 'primary' : 'secondary',
              onClick: ($event: any) => ($setup.setTab(tab.key))
            }, {
              default: _withCtx(() => [
                _createElementVNode("span", null, _toDisplayString(tab.label), 1),
                _createElementVNode("span", {
                  class: _normalizeClass(["ml-1 rounded-full px-1.5 py-0.5 text-[10px] leading-none", 
                $setup.activeTab === tab.key
                  ? 'bg-white/20 text-white'
                  : 'bg-brand-50 text-brand-700'
              ])
                }, _toDisplayString($setup.getTabCount(tab.key)), 3)
              ]),
              _: 2
            }, 1032, ["variant", "onClick"]))
          }), 128))
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_UiDatePicker, {
            modelValue: $setup.dateFrom,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.dateFrom) = $event)),
            class: "min-w-0",
            label: "Từ ngày"
          }, null, 8, ["modelValue"]),
          _createVNode(_component_UiDatePicker, {
            modelValue: $setup.dateTo,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.dateTo) = $event)),
            class: "min-w-0",
            label: "Đến ngày"
          }, null, 8, ["modelValue"]),
          _createVNode(_component_UiSelect, {
            modelValue: $setup.departmentId,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.departmentId) = $event)),
            modelModifiers: { number: true },
            class: "min-w-0",
            onChange: $setup.onDepartmentChange
          }, {
            default: _withCtx(() => [
              _cache[48] || (_cache[48] = _createElementVNode("option", { value: 0 }, "Khoa/phòng", -1)),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.departments, (item) => {
                return (_openBlock(), _createElementBlock("option", {
                  key: item.id,
                  value: item.id
                }, _toDisplayString(item.tenKhoaPhong), 9, _hoisted_6))
              }), 128))
            ]),
            _: 1
          }, 8, ["modelValue", "onChange"]),
          _createVNode(_component_UiInput, {
            modelValue: $setup.query,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (($setup.query) = $event)),
            class: "min-w-0 md:col-span-2 xl:col-span-1",
            placeholder: "Tìm thiết bị, model, khoa/phòng..."
          }, null, 8, ["modelValue"]),
          _createVNode(_component_UiButton, {
            class: "w-full md:w-auto md:justify-self-start xl:justify-self-auto",
            icon: "export",
            disabled: !$setup.currentRowsLength || $setup.exporting,
            onClick: $setup.exportExcel
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString($setup.exporting ? "Đang xuất..." : "Xuất Excel"), 1)
            ]),
            _: 1
          }, 8, ["disabled", "onClick"])
        ])
      ])
    ]),
    ($setup.isRepairTab)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass(["mt-4 table-wrap", { 'is-loading': $setup.loading }])
        }, [
          ($setup.loading)
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [...(_cache[49] || (_cache[49] = [
                _createElementVNode("span", { class: "table-spinner" }, null, -1),
                _createElementVNode("span", null, "Đang tải dữ liệu...", -1)
              ]))]))
            : _createCommentVNode("", true),
          _createElementVNode("table", _hoisted_8, [
            _createElementVNode("thead", null, [
              _createElementVNode("tr", null, [
                _cache[50] || (_cache[50] = _createElementVNode("th", null, "STT", -1)),
                _createElementVNode("th", null, [
                  _createElementVNode("p", {
                    onClick: _cache[4] || (_cache[4] = ($event: any) => ($setup.toggleSort('tenThietBi')))
                  }, " Tên thiết bị " + _toDisplayString($setup.sortMark("tenThietBi")), 1)
                ]),
                _createElementVNode("th", null, [
                  _createElementVNode("p", {
                    onClick: _cache[5] || (_cache[5] = ($event: any) => ($setup.toggleSort('maThietBi')))
                  }, " Mã thiết bị " + _toDisplayString($setup.sortMark("maThietBi")), 1)
                ]),
                _createElementVNode("th", null, [
                  _createElementVNode("p", {
                    onClick: _cache[6] || (_cache[6] = ($event: any) => ($setup.toggleSort('thoiGianBaoHong')))
                  }, " Thời gian báo hỏng " + _toDisplayString($setup.sortMark("thoiGianBaoHong")), 1)
                ]),
                _createElementVNode("th", null, [
                  _createElementVNode("p", {
                    onClick: _cache[7] || (_cache[7] = ($event: any) => ($setup.toggleSort('thoiGianSuaChua')))
                  }, " Thời gian sửa chữa " + _toDisplayString($setup.sortMark("thoiGianSuaChua")), 1)
                ]),
                _createElementVNode("th", null, [
                  _createElementVNode("p", {
                    onClick: _cache[8] || (_cache[8] = ($event: any) => ($setup.toggleSort('nguoiBaoCao')))
                  }, " Người báo cáo " + _toDisplayString($setup.sortMark("nguoiBaoCao")), 1)
                ]),
                _createElementVNode("th", null, [
                  _createElementVNode("p", {
                    onClick: _cache[9] || (_cache[9] = ($event: any) => ($setup.toggleSort('khoaPhongBaoCao')))
                  }, " Khoa phòng báo cáo " + _toDisplayString($setup.sortMark("khoaPhongBaoCao")), 1)
                ]),
                _createElementVNode("th", null, [
                  _createElementVNode("p", {
                    onClick: _cache[10] || (_cache[10] = ($event: any) => ($setup.toggleSort('noiDung')))
                  }, " Nội dung " + _toDisplayString($setup.sortMark("noiDung")), 1)
                ]),
                _createElementVNode("th", null, [
                  _createElementVNode("p", {
                    onClick: _cache[11] || (_cache[11] = ($event: any) => ($setup.toggleSort('nguoiSuaChua')))
                  }, " Người sửa chữa " + _toDisplayString($setup.sortMark("nguoiSuaChua")), 1)
                ]),
                _createElementVNode("th", null, [
                  _createElementVNode("p", {
                    onClick: _cache[12] || (_cache[12] = ($event: any) => ($setup.toggleSort('khoaPhongSuaChua')))
                  }, " Khoa phòng sửa chữa " + _toDisplayString($setup.sortMark("khoaPhongSuaChua")), 1)
                ]),
                _createElementVNode("th", null, [
                  _createElementVNode("p", {
                    onClick: _cache[13] || (_cache[13] = ($event: any) => ($setup.toggleSort('huongGiaiQuyet')))
                  }, " Hướng giải quyết " + _toDisplayString($setup.sortMark("huongGiaiQuyet")), 1)
                ]),
                _createElementVNode("th", null, [
                  _createElementVNode("p", {
                    onClick: _cache[14] || (_cache[14] = ($event: any) => ($setup.toggleSort('soTien')))
                  }, " Số tiền " + _toDisplayString($setup.sortMark("soTien")), 1)
                ]),
                ($setup.hasRepairTableActions)
                  ? (_openBlock(), _createElementBlock("th", _hoisted_9, "Thao tác"))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createElementVNode("tbody", _hoisted_10, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.paginatedRepairRows, (item, index) => {
                return (_openBlock(), _createElementBlock("tr", {
                  key: $setup.repairRowKey(item, index),
                  class: "hover:bg-slate-50"
                }, [
                  _createElementVNode("td", null, _toDisplayString($setup.rowIndex(index)), 1),
                  _createElementVNode("td", _hoisted_11, _toDisplayString(item.tenThietBi), 1),
                  _createElementVNode("td", null, _toDisplayString(item.maThietBi || "-"), 1),
                  _createElementVNode("td", null, _toDisplayString($setup.formatDate(item.thoiGianBaoHong)), 1),
                  _createElementVNode("td", null, _toDisplayString($setup.formatDate(item.thoiGianSuaChua)), 1),
                  _createElementVNode("td", null, _toDisplayString(item.nguoiBaoCao || "-"), 1),
                  _createElementVNode("td", null, _toDisplayString(item.khoaPhongBaoCao || "-"), 1),
                  _createElementVNode("td", null, _toDisplayString(item.noiDung || "-"), 1),
                  _createElementVNode("td", null, _toDisplayString(item.nguoiSuaChua || "-"), 1),
                  _createElementVNode("td", null, _toDisplayString(item.khoaPhongSuaChua || "-"), 1),
                  _createElementVNode("td", null, _toDisplayString(item.huongGiaiQuyet || "-"), 1),
                  _createElementVNode("td", null, _toDisplayString($setup.formatCurrency(item.soTien)), 1),
                  ($setup.hasRepairTableActions)
                    ? (_openBlock(), _createElementBlock("td", _hoisted_12, [
                        (!item.trangThai)
                          ? (_openBlock(), _createBlock(_component_UiButton, {
                              key: 0,
                              variant: "secondary",
                              size: "sm",
                              icon: "edit",
                              onClick: ($event: any) => ($setup.openRepairTableUpdate(item))
                            }, {
                              default: _withCtx(() => [...(_cache[51] || (_cache[51] = [
                                _createTextVNode(" Cập nhật ", -1)
                              ]))]),
                              _: 1
                            }, 8, ["onClick"]))
                          : _createCommentVNode("", true)
                      ]))
                    : _createCommentVNode("", true)
                ]))
              }), 128)),
              (!$setup.filteredRepairRows.length)
                ? (_openBlock(), _createElementBlock("tr", _hoisted_13, [
                    _createElementVNode("td", {
                      colspan: $setup.repairEmptyColspan,
                      class: "py-10 text-center text-slate-500"
                    }, " Không có dữ liệu sửa chữa phù hợp. ", 8, _hoisted_14)
                  ]))
                : _createCommentVNode("", true)
            ])
          ])
        ], 2))
      : (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: _normalizeClass(["mt-4 table-wrap", { 'is-loading': $setup.loading }])
        }, [
          ($setup.loading)
            ? (_openBlock(), _createElementBlock("div", _hoisted_15, [...(_cache[52] || (_cache[52] = [
                _createElementVNode("span", { class: "table-spinner" }, null, -1),
                _createElementVNode("span", null, "Đang tải dữ liệu...", -1)
              ]))]))
            : _createCommentVNode("", true),
          _createElementVNode("table", _hoisted_16, [
            _createElementVNode("thead", null, [
              _createElementVNode("tr", null, [
                _cache[53] || (_cache[53] = _createElementVNode("th", null, "STT", -1)),
                _createElementVNode("th", null, [
                  _createElementVNode("p", {
                    onClick: _cache[15] || (_cache[15] = ($event: any) => ($setup.toggleSort('tenThietBi')))
                  }, " Tên thiết bị " + _toDisplayString($setup.sortMark("tenThietBi")), 1)
                ]),
                _createElementVNode("th", null, [
                  _createElementVNode("p", {
                    onClick: _cache[16] || (_cache[16] = ($event: any) => ($setup.toggleSort('maThietBi')))
                  }, " Mã thiết bị " + _toDisplayString($setup.sortMark("maThietBi")), 1)
                ]),
                _createElementVNode("th", null, [
                  _createElementVNode("p", {
                    onClick: _cache[17] || (_cache[17] = ($event: any) => ($setup.toggleSort('namTiepNhan')))
                  }, " Năm tiếp nhận " + _toDisplayString($setup.sortMark("namTiepNhan")), 1)
                ]),
                _createElementVNode("th", null, [
                  _createElementVNode("p", {
                    onClick: _cache[18] || (_cache[18] = ($event: any) => ($setup.toggleSort('thoiGianCapNhat')))
                  }, " Thời gian cập nhật " + _toDisplayString($setup.sortMark("thoiGianCapNhat")), 1)
                ]),
                _createElementVNode("th", null, [
                  _createElementVNode("p", {
                    onClick: _cache[19] || (_cache[19] = ($event: any) => ($setup.toggleSort('giaTriTiepNhan')))
                  }, " Nguyên giá " + _toDisplayString($setup.sortMark("giaTriTiepNhan")), 1)
                ]),
                _createElementVNode("th", null, [
                  _createElementVNode("p", {
                    onClick: _cache[20] || (_cache[20] = ($event: any) => ($setup.toggleSort('giaTriHienTai')))
                  }, " Giá trị thời điểm tiếp nhận " + _toDisplayString($setup.sortMark("giaTriHienTai")), 1)
                ]),
                _createElementVNode("th", null, [
                  _createElementVNode("p", {
                    onClick: _cache[21] || (_cache[21] = ($event: any) => ($setup.toggleSort('tyLeSuDungConLai')))
                  }, " Tỷ lệ sử dụng còn lại " + _toDisplayString($setup.sortMark("tyLeSuDungConLai")), 1)
                ]),
                _createElementVNode("th", null, [
                  _createElementVNode("p", {
                    onClick: _cache[22] || (_cache[22] = ($event: any) => ($setup.toggleSort('yeuCauSuaChua')))
                  }, " Yêu cầu sửa chữa " + _toDisplayString($setup.sortMark("yeuCauSuaChua")), 1)
                ]),
                _createElementVNode("th", null, [
                  _createElementVNode("p", {
                    onClick: _cache[23] || (_cache[23] = ($event: any) => ($setup.toggleSort('khoaPhongTiepNhan')))
                  }, " Khoa phòng tiếp nhận " + _toDisplayString($setup.sortMark("khoaPhongTiepNhan")), 1)
                ]),
                _createElementVNode("th", null, [
                  _createElementVNode("p", {
                    onClick: _cache[24] || (_cache[24] = ($event: any) => ($setup.toggleSort('khoaPhongHienTai')))
                  }, " Khoa phòng hiện tại " + _toDisplayString($setup.sortMark("khoaPhongHienTai")), 1)
                ]),
                _createElementVNode("th", null, [
                  _createElementVNode("p", {
                    onClick: _cache[25] || (_cache[25] = ($event: any) => ($setup.toggleSort('khoaPhongChuyenGiao')))
                  }, " Khoa phòng chuyển giao " + _toDisplayString($setup.sortMark("khoaPhongChuyenGiao")), 1)
                ]),
                ($setup.hasDeviceTableActions)
                  ? (_openBlock(), _createElementBlock("th", _hoisted_17, "Thao tác"))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createElementVNode("tbody", _hoisted_18, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.paginatedRows, (item, index) => {
                return (_openBlock(), _createElementBlock("tr", {
                  key: item.id,
                  class: "hover:bg-slate-50"
                }, [
                  _createElementVNode("td", null, _toDisplayString($setup.rowIndex(index)), 1),
                  _createElementVNode("td", _hoisted_19, _toDisplayString(item.tenThietBi), 1),
                  _createElementVNode("td", null, _toDisplayString(item.maThietBi || "-"), 1),
                  _createElementVNode("td", null, _toDisplayString($setup.getReceiptYear(item.thoiGianTiepNhan)), 1),
                  _createElementVNode("td", null, _toDisplayString($setup.formatDate(item.thoiGianCapNhat)), 1),
                  _createElementVNode("td", null, _toDisplayString($setup.formatCurrency(item.giaTriTiepNhan)), 1),
                  _createElementVNode("td", null, _toDisplayString($setup.formatCurrency(item.giaTriHienTai)), 1),
                  _createElementVNode("td", null, _toDisplayString($setup.getRemainingUsage(item)), 1),
                  _createElementVNode("td", null, [
                    _createElementVNode("span", {
                      class: _normalizeClass($setup.repairRequestClass(item))
                    }, _toDisplayString($setup.repairRequestLabel(item)), 3)
                  ]),
                  _createElementVNode("td", null, _toDisplayString(item.khoaPhongTiepNhan || "-"), 1),
                  _createElementVNode("td", null, _toDisplayString(item.khoaPhongHienTai || "-"), 1),
                  _createElementVNode("td", null, _toDisplayString(item.khoaPhongChuyenGiao || "-"), 1),
                  ($setup.hasDeviceTableActions)
                    ? (_openBlock(), _createElementBlock("td", _hoisted_20, [
                        _createElementVNode("div", _hoisted_21, [
                          _createVNode(_component_UiButton, {
                            variant: "secondary",
                            size: "sm",
                            icon: "history",
                            onClick: ($event: any) => ($setup.openHistory(item))
                          }, {
                            default: _withCtx(() => [...(_cache[54] || (_cache[54] = [
                              _createTextVNode(" Lịch sử ", -1)
                            ]))]),
                            _: 1
                          }, 8, ["onClick"]),
                          ($setup.canTransfer)
                            ? (_openBlock(), _createBlock(_component_UiButton, {
                                key: 0,
                                variant: "secondary",
                                size: "sm",
                                icon: "transfer",
                                onClick: ($event: any) => ($setup.openTransfer(item))
                              }, {
                                default: _withCtx(() => [...(_cache[55] || (_cache[55] = [
                                  _createTextVNode(" Chuyển ", -1)
                                ]))]),
                                _: 1
                              }, 8, ["onClick"]))
                            : _createCommentVNode("", true),
                          ($setup.canShowRepairButton(item))
                            ? (_openBlock(), _createBlock(_component_UiButton, {
                                key: 1,
                                variant: "secondary",
                                size: "sm",
                                icon: "repair",
                                onClick: ($event: any) => ($setup.openRepair(item))
                              }, {
                                default: _withCtx(() => [...(_cache[56] || (_cache[56] = [
                                  _createTextVNode(" Sửa chữa ", -1)
                                ]))]),
                                _: 1
                              }, 8, ["onClick"]))
                            : _createCommentVNode("", true),
                          ($setup.canWaitForLiquidation)
                            ? (_openBlock(), _createBlock(_component_UiButton, {
                                key: 2,
                                variant: "secondary",
                                size: "sm",
                                icon: "send",
                                onClick: ($event: any) => ($setup.openStop(item, 'liquidation'))
                              }, {
                                default: _withCtx(() => [...(_cache[57] || (_cache[57] = [
                                  _createTextVNode(" Chờ thanh lý ", -1)
                                ]))]),
                                _: 1
                              }, 8, ["onClick"]))
                            : _createCommentVNode("", true),
                          ($setup.canLiquidate)
                            ? (_openBlock(), _createBlock(_component_UiButton, {
                                key: 3,
                                variant: "secondary",
                                size: "sm",
                                icon: "check",
                                onClick: ($event: any) => ($setup.openStop(item, 'liquidate'))
                              }, {
                                default: _withCtx(() => [...(_cache[58] || (_cache[58] = [
                                  _createTextVNode(" Thanh lý ", -1)
                                ]))]),
                                _: 1
                              }, 8, ["onClick"]))
                            : _createCommentVNode("", true),
                          _createVNode(_component_UiButton, {
                            variant: "danger",
                            size: "sm",
                            icon: "delete",
                            onClick: ($event: any) => ($setup.openDelete(item))
                          }, {
                            default: _withCtx(() => [...(_cache[59] || (_cache[59] = [
                              _createTextVNode(" Xóa ", -1)
                            ]))]),
                            _: 1
                          }, 8, ["onClick"])
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ]))
              }), 128)),
              (!$setup.filteredRows.length)
                ? (_openBlock(), _createElementBlock("tr", _hoisted_22, [
                    _createElementVNode("td", {
                      colspan: $setup.emptyColspan,
                      class: "py-10 text-center text-slate-500"
                    }, " Không có thiết bị phù hợp. ", 8, _hoisted_23)
                  ]))
                : _createCommentVNode("", true)
            ])
          ])
        ], 2)),
    _createVNode(_component_UiPagination, {
      modelValue: $setup.page,
      "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => (($setup.page) = $event)),
      total: $setup.filteredRows.length,
      "page-size": $setup.pageSize
    }, null, 8, ["modelValue", "total", "page-size"]),
    ($setup.modal)
      ? (_openBlock(), _createBlock(_component_UiModal, {
          key: 2,
          size: $setup.modal === 'history' ? 'xl' : 'md'
        }, {
          default: _withCtx(() => [
            _createElementVNode("form", {
              onSubmit: _cache[47] || (_cache[47] = _withModifiers(
//@ts-ignore
(...args) => ($setup.submitModal && $setup.submitModal(...args)), ["prevent"]))
            }, [
              _createElementVNode("div", _hoisted_24, [
                _createElementVNode("div", null, [
                  _createElementVNode("p", _hoisted_25, _toDisplayString($setup.modalTitle), 1),
                  _createElementVNode("p", _hoisted_26, _toDisplayString($setup.selectedName), 1)
                ]),
                _createVNode(_component_UiButton, {
                  variant: "ghost",
                  size: "sm",
                  icon: "close",
                  onClick: _cache[27] || (_cache[27] = ($event: any) => ($setup.modal = ''))
                }, {
                  default: _withCtx(() => [...(_cache[60] || (_cache[60] = [
                    _createTextVNode("Đóng", -1)
                  ]))]),
                  _: 1
                })
              ]),
              ($setup.modal === 'history')
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: _normalizeClass(["table-wrap", { 'is-loading': $setup.historyLoading }])
                  }, [
                    ($setup.historyLoading)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_27, [...(_cache[61] || (_cache[61] = [
                          _createElementVNode("span", { class: "table-spinner" }, null, -1),
                          _createElementVNode("span", null, "Đang tải dữ liệu...", -1)
                        ]))]))
                      : _createCommentVNode("", true),
                    _createElementVNode("table", _hoisted_28, [
                      _createElementVNode("thead", null, [
                        _createElementVNode("tr", null, [
                          _cache[62] || (_cache[62] = _createElementVNode("th", null, "Stt", -1)),
                          _cache[63] || (_cache[63] = _createElementVNode("th", null, "Trạng thái", -1)),
                          _cache[64] || (_cache[64] = _createElementVNode("th", null, "Tên thiết bị", -1)),
                          _createElementVNode("th", null, [
                            _createElementVNode("p", {
                              onClick: _cache[28] || (_cache[28] = ($event: any) => ($setup.toggleHistorySort('khoaPhongGiao')))
                            }, " Khoa phòng chuyển " + _toDisplayString($setup.historySortMark("khoaPhongGiao")), 1)
                          ]),
                          _createElementVNode("th", null, [
                            _createElementVNode("p", {
                              onClick: _cache[29] || (_cache[29] = ($event: any) => ($setup.toggleHistorySort('thoiGianGiao')))
                            }, " Thời gian chuyển " + _toDisplayString($setup.historySortMark("thoiGianGiao")), 1)
                          ]),
                          _createElementVNode("th", null, [
                            _createElementVNode("p", {
                              onClick: _cache[30] || (_cache[30] = ($event: any) => ($setup.toggleHistorySort('khoaPhongNhan')))
                            }, " Khoa phòng nhận " + _toDisplayString($setup.historySortMark("khoaPhongNhan")), 1)
                          ]),
                          _createElementVNode("th", null, [
                            _createElementVNode("p", {
                              onClick: _cache[31] || (_cache[31] = ($event: any) => ($setup.toggleHistorySort('thoiGianXacNhan')))
                            }, " Thời gian nhận " + _toDisplayString($setup.historySortMark("thoiGianXacNhan")), 1)
                          ]),
                          _createElementVNode("th", null, [
                            _createElementVNode("p", {
                              onClick: _cache[32] || (_cache[32] = ($event: any) => ($setup.toggleHistorySort('nguoiChuyen')))
                            }, " Người chuyển " + _toDisplayString($setup.historySortMark("nguoiChuyen")), 1)
                          ]),
                          _createElementVNode("th", null, [
                            _createElementVNode("p", {
                              onClick: _cache[33] || (_cache[33] = ($event: any) => ($setup.toggleHistorySort('nguoiNhan')))
                            }, " Người nhận " + _toDisplayString($setup.historySortMark("nguoiNhan")), 1)
                          ]),
                          _createElementVNode("th", null, [
                            _createElementVNode("p", {
                              onClick: _cache[34] || (_cache[34] = ($event: any) => ($setup.toggleHistorySort('giaTriTiepNhan')))
                            }, " Giá trị ban đầu " + _toDisplayString($setup.historySortMark("giaTriTiepNhan")), 1)
                          ]),
                          _createElementVNode("th", null, [
                            _createElementVNode("p", {
                              onClick: _cache[35] || (_cache[35] = ($event: any) => ($setup.toggleHistorySort('giaTriHienTai')))
                            }, " Giá trị thời điểm tiếp nhận " + _toDisplayString($setup.historySortMark("giaTriHienTai")), 1)
                          ]),
                          _createElementVNode("th", null, [
                            _createElementVNode("p", {
                              onClick: _cache[36] || (_cache[36] = ($event: any) => ($setup.toggleHistorySort('noiDung')))
                            }, " Nội dung " + _toDisplayString($setup.historySortMark("noiDung")), 1)
                          ])
                        ])
                      ]),
                      _createElementVNode("tbody", _hoisted_29, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.sortedHistory, (item, index) => {
                          return (_openBlock(), _createElementBlock("tr", {
                            key: $setup.historyKey(item, index)
                          }, [
                            _createElementVNode("td", null, _toDisplayString(index + 1), 1),
                            _createElementVNode("td", null, [
                              _createElementVNode("span", {
                                class: _normalizeClass($setup.historyStatusClass(item))
                              }, _toDisplayString($setup.historyStatusLabel(item)), 3)
                            ]),
                            _createElementVNode("td", _hoisted_30, _toDisplayString(item.tenThietBi || $setup.selectedName || "-"), 1),
                            _createElementVNode("td", null, _toDisplayString(item.khoaPhongGiao || "-"), 1),
                            _createElementVNode("td", null, _toDisplayString($setup.formatDate(item.thoiGianGiao)), 1),
                            _createElementVNode("td", null, _toDisplayString(item.khoaPhongNhan || "-"), 1),
                            _createElementVNode("td", null, _toDisplayString($setup.formatDate(item.thoiGianXacNhan)), 1),
                            _createElementVNode("td", null, _toDisplayString(item.nguoiChuyen || "-"), 1),
                            _createElementVNode("td", null, _toDisplayString(item.nguoiNhan || "-"), 1),
                            _createElementVNode("td", null, _toDisplayString($setup.formatCurrency(item.giaTriTiepNhan)), 1),
                            _createElementVNode("td", null, _toDisplayString($setup.formatCurrency(item.giaTriHienTai)), 1),
                            _createElementVNode("td", null, _toDisplayString($setup.historyContent(item)), 1)
                          ]))
                        }), 128)),
                        (!$setup.history.length)
                          ? (_openBlock(), _createElementBlock("tr", _hoisted_31, [...(_cache[65] || (_cache[65] = [
                              _createElementVNode("td", {
                                colspan: "12",
                                class: "py-8 text-center text-slate-500"
                              }, " Chưa có lịch sử. ", -1)
                            ]))]))
                          : _createCommentVNode("", true)
                      ])
                    ])
                  ], 2))
                : ($setup.modal === 'transfer')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                      _createVNode(_component_UiSelect, {
                        modelValue: $setup.transferDepartmentId,
                        "onUpdate:modelValue": _cache[37] || (_cache[37] = ($event: any) => (($setup.transferDepartmentId) = $event)),
                        modelModifiers: { number: true },
                        label: "Khoa/phòng nhận"
                      }, {
                        default: _withCtx(() => [
                          _cache[66] || (_cache[66] = _createElementVNode("option", { value: 0 }, "Chọn khoa/phòng", -1)),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.departments, (item) => {
                            return (_openBlock(), _createElementBlock("option", {
                              key: item.id,
                              value: item.id
                            }, _toDisplayString(item.tenKhoaPhong), 9, _hoisted_33))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]))
                  : ($setup.modal === 'repair' || $setup.modal === 'repairUpdate')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                        _createVNode(_component_UiSelect, {
                          modelValue: $setup.repairDepartmentId,
                          "onUpdate:modelValue": _cache[38] || (_cache[38] = ($event: any) => (($setup.repairDepartmentId) = $event)),
                          modelModifiers: { number: true },
                          label: "Khoa/phòng sửa chữa"
                        }, {
                          default: _withCtx(() => [
                            _cache[67] || (_cache[67] = _createElementVNode("option", { value: 0 }, "Chọn khoa/phòng sửa chữa", -1)),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.departments, (item) => {
                              return (_openBlock(), _createElementBlock("option", {
                                key: item.id,
                                value: item.id
                              }, _toDisplayString(item.tenKhoaPhong), 9, _hoisted_35))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["modelValue"]),
                        _createVNode(_component_UiDatePicker, {
                          modelValue: $setup.dateRepair,
                          "onUpdate:modelValue": _cache[39] || (_cache[39] = ($event: any) => (($setup.dateRepair) = $event)),
                          label: "Thời gian báo hỏng"
                        }, null, 8, ["modelValue"]),
                        _createVNode(_component_UiTextarea, {
                          modelValue: $setup.content,
                          "onUpdate:modelValue": _cache[40] || (_cache[40] = ($event: any) => (($setup.content) = $event)),
                          label: "Nội dung",
                          required: ""
                        }, null, 8, ["modelValue"])
                      ]))
                    : ($setup.modal === 'repairComplete')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
                          _createVNode(_component_UiDatePicker, {
                            modelValue: $setup.repairCompleteDate,
                            "onUpdate:modelValue": _cache[41] || (_cache[41] = ($event: any) => (($setup.repairCompleteDate) = $event)),
                            label: "Thời gian sửa chữa",
                            required: ""
                          }, null, 8, ["modelValue"]),
                          _createVNode(_component_UiInput, {
                            "model-value": $setup.repairCompleteCostInput,
                            label: "Số tiền",
                            inputmode: "numeric",
                            onKeydown: $setup.blockNonNumericKey,
                            onPaste: _cache[42] || (_cache[42] = ($event: any) => ($setup.pasteNumericOnly($event, $setup.updateRepairCompleteCost))),
                            "onUpdate:modelValue": $setup.updateRepairCompleteCost
                          }, null, 8, ["model-value", "onKeydown", "onUpdate:modelValue"]),
                          _createVNode(_component_UiSelect, {
                            modelValue: $setup.repairCompleteCode,
                            "onUpdate:modelValue": _cache[43] || (_cache[43] = ($event: any) => (($setup.repairCompleteCode) = $event)),
                            label: "Hướng giải quyết"
                          }, {
                            default: _withCtx(() => [...(_cache[68] || (_cache[68] = [
                              _createElementVNode("option", { value: "" }, "Chọn mã giải quyết", -1),
                              _createElementVNode("option", { value: "01" }, "Thanh lý", -1),
                              _createElementVNode("option", { value: "02" }, "Đã sửa", -1)
                            ]))]),
                            _: 1
                          }, 8, ["modelValue"]),
                          _createVNode(_component_UiTextarea, {
                            modelValue: $setup.repairCompleteContent,
                            "onUpdate:modelValue": _cache[44] || (_cache[44] = ($event: any) => (($setup.repairCompleteContent) = $event)),
                            label: "Nội dung giải quyết",
                            required: ""
                          }, null, 8, ["modelValue"])
                        ]))
                      : ($setup.modal === 'delete')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
                            _createElementVNode("p", _hoisted_38, [
                              _cache[69] || (_cache[69] = _createTextVNode(" Bạn có chắc chắn muốn xóa thiết bị ", -1)),
                              _createElementVNode("span", _hoisted_39, _toDisplayString($setup.selectedName), 1),
                              _cache[70] || (_cache[70] = _createTextVNode(" không? ", -1))
                            ])
                          ]))
                        : ($setup.modal)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_40, [
                              _createVNode(_component_UiTextarea, {
                                modelValue: $setup.reason,
                                "onUpdate:modelValue": _cache[45] || (_cache[45] = ($event: any) => (($setup.reason) = $event)),
                                label: "Lý do",
                                required: ""
                              }, null, 8, ["modelValue"])
                            ]))
                          : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_41, [
                _createVNode(_component_UiButton, {
                  variant: "secondary",
                  icon: "cancel",
                  onClick: _cache[46] || (_cache[46] = ($event: any) => ($setup.modal = ''))
                }, {
                  default: _withCtx(() => [...(_cache[71] || (_cache[71] = [
                    _createTextVNode("Hủy", -1)
                  ]))]),
                  _: 1
                }),
                ($setup.modal !== 'history')
                  ? (_openBlock(), _createBlock(_component_UiButton, {
                      key: 0,
                      type: "submit",
                      variant: $setup.modal === 'delete' ? 'danger' : 'primary',
                      icon: $setup.modal === 'delete' ? 'delete' : 'confirm',
                      loading: $setup.modal === 'delete' && $setup.deletingDevice,
                      disabled: $setup.isSubmitDisabled
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString($setup.modal === "delete" ? "Xác nhận xóa" : "Xác nhận"), 1)
                      ]),
                      _: 1
                    }, 8, ["variant", "icon", "loading", "disabled"]))
                  : _createCommentVNode("", true)
              ])
            ], 32)
          ]),
          _: 1
        }, 8, ["size"]))
      : _createCommentVNode("", true)
  ]))
}